(() => {
  const checkoutButton = "[data-cart-drawer-checkout]";

  function resetCheckoutLoading() {
    const button = document.querySelector(checkoutButton);
    if (!button) return;

    button.removeAttribute("aria-busy");
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest(checkoutButton);
    if (!button) return;

    button.setAttribute("aria-busy", "true");
  });

  window.addEventListener("pageshow", resetCheckoutLoading);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") resetCheckoutLoading();
  });
})();
